import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class CodeFormatting extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Formatting</title>
                    <meta name="description" content="Formatting" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Code"  breadcrumb_2="Formatting" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Formatting And Spacing</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                        <h4>Let's make it simple</h4>
                        <p className="text-sm">
                            In order to promote uniformity between code bases the formatting and spacing of all code written should be as follows: 4 spaces per indent and line breaks where appropriate.<br/>
                            If you use a smaller screen and prefer 2 spaces per indent that is fine however all code written for Architeck must have 4 spaces per indent. This is very important as it keeps all code looking and reading in sync with each other.
                        </p>

                        <Row>
                            <Col lg={6}>
                            <h4 className="text-success">Correct Spacing</h4>
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`componentDidMount = () => {

----this.setSet({
--------isFormattedCorrectly: true
----})

}`}
</SyntaxHighlighter>    

                            </Col>
                            <Col lg={6}>
                            <h4 className="text-danger">Incorrect Spacing</h4>
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`componentDidMount = () => {

--this.setSet({
----isFormattedCorrectly: false
--})

}`}
</SyntaxHighlighter>  
                            </Col>
                        </Row>


                     

                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default CodeFormatting